import {
    SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_BEGIN,
    SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_SUCCESS,
    SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_FAILURE,
    SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_DISMISS_ERROR,
  } from '../constants'
  import axios from 'axios'
  import { REACT_APP_COTIZADOR_API } from '../../../../common/config'

    const MULTIPLICADOR_COTIZACION = 1
   
  export function getCotizacion(params) {
      const {
          year,
          kilometraje,
          brand,
          brandId,
          model,
          modelId,
          version,
          versionId
      } = params
      return (dispatch) => {
          // optionally you can have getState as the second argument
          dispatch({
              type: SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_BEGIN,
              data: params,
          })

          return new Promise((resolve, reject) => {
              // Armo el body para la consulta
              const body_cotizador = {
                  costs: [
                      {
                          type: 'general',
                          amount: 0
                      },
                      {
                          type: 'cubiertas',
                          amount: 0
                      }
                  ],
                  interior: 5, // 10: excelente, 5: bueno, 0: malo
                  kms: kilometraje,
                  vehicle: {
                      brand: brandId,
                      brandName: brand,
                      model: modelId,
                      modelName: model,
                      version: versionId,
                      versionName: version,
                      year: year
                  }
              }
              const doRequest = axios.post(
                  REACT_APP_COTIZADOR_API + '/cotizador/v1/quotes',
                  body_cotizador
              )
              doRequest.then(
                  res => {
                      dispatch({
                          type: SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_SUCCESS,
                          data: res.data,
                          params: params
                      })
                      resolve(res)
                  },
                  () => {
                      dispatch({
                          type: SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_FAILURE,
                          data: {
                              error: 'El vehículo no se encuentra segmentado',
                              ...params
                          },
                      })
                      reject({
                          message: 'El vehículo no se encuentra segmentado'
                      })
                  }
              )
          })
      }
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetCotizacionError() {
    return {
      type: SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_BEGIN:
        // Just after a request is sent
        return {
          ...state,
        }
  
      case SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_SUCCESS: {
        // The request is success
        const estimatedPrice = action?.data?.quote?.prices.find((price) => price?.type === 'estimated') || 0
        return {
          ...state,
          quotes: [...state.quotes, {quote_id: action.data.id}],
          entregaUsados:state?.entregaUsados.concat({
            final_take_price: estimatedPrice.amount * MULTIPLICADOR_COTIZACION,
            original_price: estimatedPrice.amount * MULTIPLICADOR_COTIZACION,
            ...action.params,
            quotation_id: action?.data?.id,
            km: action?.params?.kilometraje,
            valid: true,
            pending: false,
            error: null,
            patente: action?.params.matricula,
          }),
          getCotizacionPending: false,
          getCotizacionError: null,
        }}
  
      case SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_FAILURE:
        // The request is failed
        return {
          ...state,
          getCotizacionPending: false,
          getCotizacionError: action.data.error,
        }
  
      case SAVINGS_PLAN_SUBSCRIPTION_GET_COTIZACION_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getCotizacionPending: false,
          getCotizacionError: null,
        }
  
      default:
        return state
    }
  }
  